import AuthAPI from '../../api/auth';

import Crud, { TAC } from '../../api/crud';
import Storage from '../../helpers/storage.helpers';

import TranslationRepository from '../../repositories/translation-repository';
import keyBy from 'lodash/keyBy';

import {
   AUTH_AUTHENTICATED,
   AUTH_DISCONNECTED,
   AUTH_LOADING,
   AUTH_LOADED,

   CHANGED_TAC,
   CHANGED_TAC_INFO,
   USERS_CHANGED_CURRENT,
   SETTINGS_CHANGED,

   LOCALIZATION_LOADED,
   LANGUAGES_LOADED
} from '../mutation-types';

import { AUTH_CHECK, LOGIN, LOGOUT, LOAD_TAC, ACCEPT_TAC, AUTH_USER } from '../actions';
import isEmpty from 'lodash/isEmpty';
import negate from 'lodash/negate';

const api = AuthAPI;

const tacAPI = new Crud(TAC);

const existy = negate(isEmpty);

const state = {
   isAuth   : false,
   loading  : false,
   tacAcceptRequired: false,
   tacText  : '',
   tacId    : '0',
   l10n     : [],
   languages: []
};

const getters = {
   getTacText: state => state.tacText,
   l10n:       state => state.l10n.reduce((memo, e) => {
      memo[e.key] = e.text;
      return memo;
   }, {}),
   currentLanguage: (state, getters) => {
      const lang = getters.language;
      const [language] = state.languages.filter(l => l.code === lang);
      return language || null;
   },
   pluralRuleIndex: (state, getters) => {
      const lang = getters.currentLanguage;
      return lang ? lang.pluralIndex : 1;
   },
   currentLanguageLabel: (state, getters) => getters.currentLanguage ? getters.currentLanguage.name : ''
};

const actions = {
   async [AUTH_CHECK]({commit, dispatch}) {
      commit(AUTH_LOADING);
      const { redirectUrl, ga, user, tacAcceptRequired, muxApiKey } = await api.state();
      commit(SETTINGS_CHANGED, { redirectUrl, gaid: ga, muxApiKey });
      dispatch(AUTH_USER, { user, tacAcceptRequired });
   },
   async [LOGOUT]({commit}) {
      Storage.remove('guard', 'auth-key');
      await api.logout();
      commit(AUTH_DISCONNECTED);
   },
   async [LOGIN]({commit, dispatch}, { username, password }) {
      commit(AUTH_LOADING);
      const { user, tacAcceptRequired } = await api.auth(username, password);
      dispatch(AUTH_USER, { user, tacAcceptRequired });
   },
   async [AUTH_USER]({commit, dispatch}, {user, tacAcceptRequired}) {
      commit(CHANGED_TAC, !!tacAcceptRequired);
      commit(USERS_CHANGED_CURRENT, user);
      if (existy(user)) {
         Storage.set('user', 'language', user.language);
         const repository = new TranslationRepository();
         const { translations, languages } = await repository.load({});
         commit(LOCALIZATION_LOADED, translations);
         commit(LANGUAGES_LOADED, languages);
         commit(AUTH_AUTHENTICATED);
      } else {
         commit(AUTH_LOADED);
      }
   },
   async [ACCEPT_TAC]({ commit, state }) {
      try {
         await tacAPI.save({ id: state.tacId }, { forcePost: true });
         commit(CHANGED_TAC, false);
      } catch(e) {
         //
      }
   },
   async [LOAD_TAC]({ commit }) {
      const { id, tacText } = await tacAPI.load();
      commit(CHANGED_TAC_INFO, { id, tacText });
   }
};

const mutations = {
   [AUTH_LOADING](state) {
      state.loading = true;
   },
   [AUTH_AUTHENTICATED](state) {
      state.isAuth  = true;
      state.loading = false;
   },
   [AUTH_DISCONNECTED](state) {
      state.isAuth  = false;
      state.loading = false;
   },
   [AUTH_LOADED](state) {
      state.loading = false;
   },
   [CHANGED_TAC](state, flag) {
      state.tacAcceptRequired = flag;
   },
   [CHANGED_TAC_INFO](state, { id, tacText }) {
      state.tacText = tacText;
      state.tacId = id;
   },
   [LOCALIZATION_LOADED](state, translations) {
      state.l10n = translations;
   },
   [LANGUAGES_LOADED](state, languages) {
      state.languages = languages;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};
